import styled from "styled-components";

export const LayoutOne = styled.div``;
